import { PropsWithChildren } from "react";
import styled from "styled-components";
import Body from "ui/Text/Body";

interface ChipProps {
  className?: string;
}

const Chip = ({ children, className }: PropsWithChildren<ChipProps>) => {
  return <ChipContainer className={className}>{children}</ChipContainer>;
};

export default Chip;

const ChipContainer = styled.div`
  padding: 8px 24px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 40px;
  background-color: ${({ theme }) => theme.colors.grayScale.lightest};
`;
